
import { Component, Vue, Prop } from 'vue-property-decorator';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import RestaurantSelector from '@/components/shared/RestaurantSelector.vue';

@Component({
	components: {
		StandardModal,
		RestaurantSelector
	}
})
export default class OrdersReportExportModal extends Vue {
	@Prop({ type: Boolean, default: false }) private showModal!: boolean;
	@Prop({ type: Boolean, default: false }) private loading!: boolean;

	private selectedRestaurantIds: string[] = [];
	private restaurantError: string = '';
}
